<!-- loading spinner -->
<div *ngIf="isLoading" class="text-center m-3">
  <app-spinner size="l" dark="true"></app-spinner>
  <p>{{'LOADING'|translate}}</p>
</div>

<ng-container *ngIf="!isLoading">
  <!-- display error if no data -->
  <p *ngIf="!reservation">{{'NO_DATA_FOUND'|translate}}</p>

  <div *ngIf="reservation" class="alert alert-info" role="alert">
    <h3>{{viewData.title}}</h3>

    <p [innerHTML]="viewData.mainText"></p>

    <p [innerHTML]="viewData.subText"></p>

    <app-button text="{{'SAVE_EVENTS_TO_CALENDAR'|translate}}" [working]="isButtonLoading" (click)="onDownloadIcs()">
    </app-button>

    <p class="mt-3">{{'FIND_RESERVATION_LIST_AT'|translate}} <a routerLink="/my"
        routerLinkActive="active">{{'MY_RESERVATIONS'|translate}}</a>.</p>
  </div>

</ng-container>